import { z } from 'zod';
import { requiredString } from '@/shared/lib/validation';

/** Валидирует форму отправки текстового сообщения */
export const chatMessageSchema = z.object({
    message: requiredString('Введите сообщение'),
});

/** Значения формы отправки сообщения */
export type ChatMessageFormValues = z.infer<typeof chatMessageSchema>;

/** Начальные значения формы отправки сообщения */
export const CHAT_MESSAGE_DEFAULT_VALUES: ChatMessageFormValues = {
    message: '',
};

/** Валидирует форму заметки оператора */
export const chatNoteSchema = z.object({
    note: z.string(),
});

/** Значения формы заметки оператора */
export type ChatNoteFormValues = z.infer<typeof chatNoteSchema>;

/** Начальные значения формы заметки оператора */
export const CHAT_NOTE_DEFAULT_VALUES: ChatNoteFormValues = {
    note: '',
};
